import { DependentCardModel } from './dependentCard.model';
import { ConfigurationModel } from './configuration.model';
import { ConsumptionModel } from './consumption.model';
import { CompanyModel } from './company.model';
import { ImageModel } from './image.model';
import { InputModel } from '../components/input/input.model';
import { RequiredModel } from '../components/input/rules/implementations/required.model';
import { MeepCardNameModel } from '../components/input/rules/implementations/meepCardName.model';

export class StatusCartaoCashless {
  Descricao: string;
  Id: number;
}

export class TipoReembolso {
  Descricao: string;
  Id: number;

  // 0 - Desabilitado
  // 1 - Parcial
  // 2 - Total
}

export class PedidosDevedores {
  Valor: number;
  Id: string;
  DataRealizacao: Date = new Date();
}

export class DependentMeepServerModel {
  Apelido: string;
  DataCriacao: Date;
  DataModificacao: Date;
  Id: string;
  LimiteDiario: number;
  NomeTitular: string;
  Saldo: number;
  Senha: string;
  Status: StatusCartaoCashless;
  Tag: string;
  Numero: string;
  NomeDoLocal: string;
  LocalClienteId: string;
  EstimativaConsumo: number;
  TotalConsumo: number;
  EhSegundaViaCashlessEmitidaPeloLocal: boolean;
  HistoricoAssociacaoId: string;
  AceitaBoleto: boolean;
  EhDevedores: boolean;
  EhNominal: boolean;
  Documento: string;
  DataAssociacao: Date;
  DataDesassociacao: Date;
  TipoReembolso: TipoReembolso;
  CobrarTaxaUsuarioPorBoleto: boolean;
  ValorTaxaUsuarioPorBoleto: number;
  SaldoMinimo: number;
  LinkMaisInformacoes: string;
  ValorTaxaRecarga: number;
  EhProducao: boolean;

  constructor() {
    this.Status = new StatusCartaoCashless();
    this.TipoReembolso = new TipoReembolso();
    this.Saldo = 0;
    this.EstimativaConsumo = 0;
    this.TotalConsumo = 0;
    this.ValorTaxaRecarga = 0;
  }
}

export class DependentModel {

  id: string;
  name: string;
  localBirth: string;
  birth: Date;
  card: DependentCardModel;
  configuration: ConfigurationModel;
  nickname: string;
  topConsumptions: ConsumptionModel[];
  consumptionBalance: number;
  document: string;
  company: CompanyModel;
  password: string;
  cardNumber: string;
  photo: ImageModel;

  dependentMeepServerModel: DependentMeepServerModel;

  nomeInputModel = new InputModel(false, false, 'text', 'Nome', [new RequiredModel()]);
  cardNumberInputModel = new InputModel(false, false, 'text', 'Cartão Meep', [new RequiredModel()]);
  cardNumberInputModelNotRequired = new InputModel(false, false, 'text', 'Cartão Meep opcional', []);
  // tslint:disable-next-line:max-line-length
  nicknameInputModel = new InputModel(false, false, 'text', 'Apelido', [new MeepCardNameModel(), new RequiredModel()], new MeepCardNameModel());

  constructor() {
    this.card = new DependentCardModel();
    this.photo = new ImageModel();
    this.configuration = new ConfigurationModel();
    this.topConsumptions = new Array<ConsumptionModel>();
    this.company = new CompanyModel();
    this.dependentMeepServerModel = new DependentMeepServerModel();
    this.nicknameInputModel.setUpperCase();
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/models/dependent.model.ts